// extracted by mini-css-extract-plugin
module.exports = {"container":"LegalDisclaimer_container__3DHpw","link":"LegalDisclaimer_link__36_LV"};